export const headCells = [
  {
    id: 'createdDate',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Дата создания',
  },
  {
    id: 'endTime',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Дата окончания',
  },
  {
    id: 'priority',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Приоритет',
    style: { maxWidth: '100px' },
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Статус',
  },
  {
    id: 'situationDescription',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Описание ситуации',
  },

  {
    id: 'solutionDescription',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Решение',
  },

  {
    id: 'lastModifiedDate',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Дата решения',
  },

  {
    id: 'lastModifiedBy',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Пользователь',
  },
];

export const displayedCells = [
  'createdDate',
  'endTime',
  'priority',
  'status',
  'situationDescription',
  'solutionDescription',
  'lastModifiedDate',
  'lastModifiedBy',
];
